import { computed, toJS } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { IGetDirectLineTokenData } from '../../actions/get-direct-line-token.action';
import { ILxsServiceAgentData } from './lxs-service-agent.data';
import { ILxsServiceAgentProps } from './lxs-service-agent.props.autogenerated';

export interface ILxsServiceAgentViewProps extends ILxsServiceAgentProps<ILxsServiceAgentData> {
    directLineToken: IGetDirectLineTokenData;
    CLASS_NAME: string;
}

/**
 *
 * LxsServiceAgent component
 * @extends {React.PureComponent<ILxsServiceAgentProps<ILxsServiceAgentData>>}
 */

@observer
class LxsServiceAgent extends React.PureComponent<ILxsServiceAgentProps<ILxsServiceAgentData>> {
    @computed
    get directLineToken(): IGetDirectLineTokenData {
        const raw = toJS(this.props.data?.getDirectLineToken?.result);
        if (!raw) {
            return {} as IGetDirectLineTokenData;
        }
        return raw;
    }

    public render(): JSX.Element | null {
        const directLineToken = this.directLineToken;
        const CLASS_NAME = 'lxs-service-agent';
        return this.props.renderView({ ...(this.props as ILxsServiceAgentProps<ILxsServiceAgentData>), directLineToken, CLASS_NAME });
    }
}

export default LxsServiceAgent;
